module.exports = __webpack_public_path__ + "static/media/incoterms_kr.1c300643.jpg";